import { Store } from './state';

export type Route = 'home' | 'upload' | 'review' | 'suggest' | 'settings';

export const router = new Store<Route>('home');

export function startRouter() {
  const apply = () => {
    const hash = location.hash.replace(/^#\/?/, '') as Route;
    const valid: Route[] = ['home', 'upload', 'review', 'suggest', 'settings'];
    router.set(valid.includes(hash) ? hash : 'home');
  };
  window.addEventListener('hashchange', apply);
  apply();
}

export function go(route: Route) {
  location.hash = `#/${route}`;
}
